import React from "react";
import FormRoute from "./FormRoute";
import FormVehicleInfo from "./FormVehicleInfo";
import FormClientInfo from "./FormClientInfo";
import FormFaliure from "./FormFaliure";
import FormVehicleOverview from "./FormVehicleOverview";
import "./UserForm.css";
import FormThankYou from "./FormThankYou";
import { DEFAULT_TO_TEXT, DEFAULT_FROM_TEXT } from "../../App";

export const FORM_HEADING_DOOR_TO_DOOR = "Door to Door";
export const FORM_HEADING_DEPOT_TO_DEPOT = "Depot to Depot";

const UserForm = ({ depotList, toDepotList, selectedFrom, setSelectedFrom, selectedTo, estimatePrice, setSelectedTo, stepperSetter, quote, vehicleList,
    addRemoveVehicle, formStage, setFormStage, disabledDays }) => {

    const [isOnDepotToDepot, setIsOnDepotToDepot] = React.useState(true);

    React.useEffect(stepperSetter.bind(null, formStage), [formStage]);

    const [formHeading, setFormHeading] = React.useState(
        FORM_HEADING_DOOR_TO_DOOR
    );

    function nextStep() {
        console.log(isOnDepotToDepot);
        if (isOnDepotToDepot && (selectedFrom !== DEFAULT_FROM_TEXT && selectedTo !== DEFAULT_TO_TEXT)) {
            setFormStage(formStage + 1);
        } else if (!isOnDepotToDepot) {
            setFormStage(formStage + 1);
        } else {
            window.alert("Please select a from and to depot");
        }
    }

    function prevStep() {
        setFormStage(formStage - 1);
    }

    function showFailPage() {
        setFormStage(5);
    }

    return (
        <div>
            {formStage === 1 && (
                <FormRoute depotList={depotList} toDepotList={toDepotList} selectedFrom={selectedFrom} setSelectedFrom={setSelectedFrom} selectedTo={selectedTo} setSelectedTo={setSelectedTo}
                    estimatePrice={estimatePrice} setFormHeading={setFormHeading} setIsOnDepotToDepot={setIsOnDepotToDepot} nextStep={nextStep} quote={quote} />
            )}
            {formStage === 2 && (
                <div>
                    <FormVehicleInfo nextStep={nextStep} prevStep={prevStep} formHeading={formHeading} quote={quote} addRemoveVehicle={addRemoveVehicle} vehicleList={vehicleList} />
                </div>
            )}
            {formStage === 3 && (
                < FormVehicleOverview nextStep={nextStep} prevStep={prevStep} formHeading={formHeading} showFailPage={showFailPage} quote={quote} addRemoveVehicle={addRemoveVehicle} vehicleList={vehicleList} />
            )}
            {formStage === 4 && (
                <FormClientInfo nextStep={nextStep} prevStep={prevStep} formHeading={formHeading} showFailPage={showFailPage} quote={quote} vehicleList={vehicleList} disabledDays={disabledDays} />
            )}

            {formStage === 5 && (
                <FormThankYou nextStep={nextStep} formHeading={formHeading} quote={quote} vehicleList={vehicleList} />
            )}
            {formStage === 6 && (
                <FormFaliure />
            )}
        </div>

    );
};

export default UserForm;
